import { Controller } from "@hotwired/stimulus";
import { releaseFocusTrap } from '../utils/FocusTrap';

export default class extends Controller {
  hideModal() {
    const el = document.getElementById('openQuestionContainer');
    if (el) {
      releaseFocusTrap(el);
      el.classList.add('hidden');
    }
  }

  openSaveQuizTodoModal(event) {
    this.hideModal();
    document.getElementById('todoURLButton').click();
    event.stopPropagation();
  }
}
